export default "__VITE_ASSET__BlW1tu_H__"